var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcPedidoEnviado = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#2ABA83;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2ABA83;}\r\n\t.st2{fill:#D4145A;}\r\n\t.st3{fill:#363636;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#30323A;}\r\n\t.st7{font-family:'Poppins-Regular';}\r\n\t.st8{font-size:3.9346px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolsas_e_Olheiras"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hidratante"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Repelente"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guias"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Barba"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calv\\xEDcie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Clareador"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beleza"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Iluminador"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Preechedor"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Crescimento_Capilar"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Pesco\\xE7o_e_Colo"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Cabelo"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sa\\xFAde"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Unha"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Protetor_Solar"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.77,34.64C52.77,34.64,52.77,34.64,52.77,34.64l-3.63-7.87c-0.76-1.64-2.41-2.7-4.22-2.7H39.5 c-0.24-1.9-1.84-3.38-3.81-3.38c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5c1.57,0,2.86,1.28,2.86,2.86v0.02v17.04H26.44 c-0.24-1.5-1.54-2.65-3.1-2.65s-2.86,1.15-3.1,2.65h-4.37v-2.79h3.52c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-3.52V24.55 c0-1.57,1.28-2.86,2.86-2.86h15c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-15c-2.13,0-3.86,1.73-3.86,3.86v17.57 c0,0.28,0.22,0.5,0.5,0.5h4.87c0.24,1.5,1.53,2.65,3.1,2.65s2.86-1.15,3.1-2.65h12.61h1.82c0.24,1.5,1.54,2.65,3.1,2.65 s2.86-1.15,3.1-2.65h5.23c0.28,0,0.5-0.22,0.5-0.5v-7.27C52.81,34.77,52.79,34.7,52.77,34.64z M23.33,44.27 c-1.19,0-2.15-0.97-2.15-2.15c0-1.19,0.97-2.15,2.15-2.15c1.19,0,2.15,0.97,2.15,2.15C25.49,43.3,24.52,44.27,23.33,44.27z  M48.34,27.43l3.19,6.92h-7.02c-0.75,0-1.36-0.61-1.36-1.36v-4.2c0-0.75,0.61-1.36,1.36-1.36H48.34z M43.97,44.27 c-1.19,0-2.15-0.97-2.15-2.15c0-1.19,0.97-2.15,2.15-2.15c1.19,0,2.15,0.97,2.15,2.15C46.13,43.3,45.16,44.27,43.97,44.27z  M47.08,41.62c-0.24-1.5-1.53-2.65-3.1-2.65s-2.86,1.15-3.1,2.65h-1.32V25.07h5.38c1.11,0,2.14,0.51,2.82,1.35h-3.24 c-1.3,0-2.36,1.06-2.36,2.36v4.2c0,1.3,1.06,2.36,2.36,2.36h7.3v2.48h-2.72c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h2.72v2.79 H47.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.13,38.33c0,0.28,0.22,0.5,0.5,0.5h8.81c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-8.81 C27.35,37.83,27.13,38.05,27.13,38.33z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.48,30.01c0-0.02,0-0.04,0-0.07c0-0.06-0.02-0.12-0.04-0.18c-0.01-0.01,0-0.03-0.01-0.04 c0,0-0.01-0.01-0.01-0.01c0,0,0-0.01-0.01-0.02l-3.39-5.39c-0.15-0.23-0.46-0.3-0.69-0.16c-0.23,0.15-0.3,0.46-0.16,0.69l2.91,4.62 H10.19c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h14.89l-2.91,4.62c-0.15,0.23-0.08,0.54,0.16,0.69c0.08,0.05,0.17,0.08,0.27,0.08 c0.17,0,0.33-0.08,0.42-0.23l3.39-5.39c0.01-0.01,0-0.02,0.01-0.03C26.45,30.14,26.47,30.08,26.48,30.01z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "label",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 16.045 58.6176)",
    className: "st6 st7 st8"
  }, "PEDIDO ENVIADO"))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPedidoEnviado, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-pedido-enviado.6973e173.svg";
export { ForwardRef as ReactComponent };